import { Component } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { AuthService } from "bp-authorization-lib";
import { UserService } from "@main-services/user.service";

@Component({
	templateUrl: "./user.component.html",
	standalone: false
})
export class UserComponent {
	public constructor(
		private route: ActivatedRoute,
		private userService: UserService,
		private authService: AuthService
	) {
		this.route.params.forEach((params: Params) => {
			// OAuth implementation
			if (this.authService.checkValidUserRoute(params)) {
				this.authService.setRedirectPath(this.userService.redirect);
				this.authService.initAuthorization(params);
			}
			return;
		});
	}
}
